import { useQuery } from "@tanstack/react-query";
import React from "react";
import styled from "styled-components";

import Table from "../../components/core-components/Table.tsx";

import Modal from "../../components/core-components/Modal.tsx";

import { toast, ToastContainer } from "react-toastify";
import { getCategories } from "../../../services/productsService.js";

import PageHeader from "../../components/PageHeader.tsx";
import AddCategoryComponent from "../../components/core-components/AddCategoryComponent.tsx";
import Scrollbars from "react-custom-scrollbars-2";
import { useNavigate } from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;
const Content = styled.div`
  box-sizing: border-box;
  background-color: white;
  width: calc(100% - 2rem);
  min-height: 80%;
  border-radius: 8px;
  padding: 20px;

  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

interface Props {}

const notify = () =>
  toast.success("Categorie adăugat cu succes !", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });

const notifyError = () =>
  toast.error("Categorie nu s-a putut adăuga !", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });
const CategoryPage: React.FC<Props> = ({}) => {
  const [isModalOpen, setModalOpen] = React.useState(false);
  const navigate = useNavigate();
  const { data: categories, refetch } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
  });

  return (
    <Wrapper>
      <PageHeader
        pageTitle="Categorii de produse"
        actionButtons={[
          {
            label: "Adaugă categorie",
            onClick: () => {
              setModalOpen(true);
            },
            isEmpty: true,
          },
        ]}
      />
      <Content>
        <Scrollbars style={{ width: "100%" }}>
          <Table
            columns={[
              { title: "ID", key: "categoryID" },
              { title: "Nume", key: "categoryName" },
            ]}
            rows={categories || []}
            onRowClick={(row) => {
              navigate(`/backoffice/category/${row.categoryID}`);
            }}
          />
        </Scrollbars>
      </Content>

      {isModalOpen && (
        <Modal
          name="add-type-modal"
          title={"Adaugă categorie"}
          onClose={() => setModalOpen(false)}
          content={
            <AddCategoryComponent
              closeAddMode={(result) => {
                setModalOpen(false);
                if (result === "success") {
                  notify();
                  // refetch();
                } else if (result === "error") {
                  notifyError();
                }
              }}
            />
          }
        />
      )}
      <ToastContainer />
    </Wrapper>
  );
};
export default CategoryPage;
